<div class="wrapper-card-post">
  <div class="header-card-post">
    <div class="user-card-post">
      <img class="user-img"
           *ngIf="!post.user.profile_photo_url"
           [routerLink]="[PAGES_AND_PATHS.profile.pagePath, post.user.username]"
           [src]="(post.user.subscriptions | checkActiveRole) === UserRoles.freemium ? '../../../../../assets/images/avatar-user.png' : '../../../../../assets/images/avatar-user-expert.png'"
           alt="">
      <img class="user-img"
           *ngIf="post.user.profile_photo_url"
           [routerLink]="[PAGES_AND_PATHS.profile.pagePath, post.user.username]"
           [src]="post.user.profile_photo_url" alt="">
      <div class="wrapper-user-card-info-post">
        <div class="user-name">
          <span>{{post.user.name}}</span>
          <img *ngIf="(post.user.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../../../assets/icons/fill/icon-badge.svg" alt="">
          <img *ngIf="(post.user.subscriptions | checkActiveRole) === UserRoles.company" src="../../../../../assets/icons/fill/icon-fill-company.svg" alt="">
        </div>
        <span *ngIf="post.updated_at">{{post.updated_at | timeAgo}}</span>
      </div>
    </div>
    <div class="wrapper-dropdown-btn">
      <div  #viewMoreBtn (click)="$event.stopPropagation(); isCallToActionModal = !isCallToActionModal" class="view-more-post">
        <img src="../../../../assets/icons/outline/icon-view-more.svg" alt="">
      </div>
      <div *ngIf="isCallToActionModal" class="content-dropdown-btn">
        <div (click)="onCallActionSharePost($event)" class="item-dropdown">
          <img src="../../../../assets/icons/outline/icon-share.svg" alt="">
          <span>{{'GENERAL.share' | translate}}</span>
        </div>
        <div (click)="onCallActionReportPost($event)" class="item-dropdown delete">
          <img src="../../../../assets/icons/outline/icon-outline-attention.svg" alt="">
          <span>
            {{'LIST_SINGLE_PAGE.report' | translate}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="content-card-post">
    <p class="description">
      {{post.content | handleShowMore: 100: isShowMore}} <span
        (click)="$event.stopPropagation(); isShowMore = !isShowMore" *ngIf="post.content.length > 100">{{isShowMore ?
        'less' : 'more'}}</span>
    </p>
    <div *ngIf="post.lyst !== null || post.lyst_item !== null" class="wrapper-image-tagged">
      <img *ngIf="post.lyst && post.lyst?.lyst_image_url" [src]="post.lyst?.lyst_image_url" [alt]="post.lyst?.title + '-image'">
      <img *ngIf="post.lyst && post.lyst?.lyst_image_url === null" [src]="'assets/images/no-image.png'" [alt]="post.lyst?.title + '-image'">
      <img *ngIf="post.lyst_item && post.lyst_item?.lyst_item_image_url" [src]="post.lyst_item?.lyst_item_image_url"
           [alt]="post.lyst_item?.name  + '-image'">
      <img *ngIf="post.lyst_item && post.lyst_item?.lyst_item_image_url === null" [src]="'assets/images/no-image.png'"
           [alt]="post.lyst_item?.name  + '-image'">
    </div>
    <div *ngIf="post?.lyst !== null || post?.lyst_item !== null" class="wrapper-tagged-list-item">
      <div class="wrapper-tags">
        <div *ngIf="post?.lyst !== null" class="wrapper-tag list">
          <img src="../../../../../assets/icons/outline/icon-tag.svg" alt="">
          <span>{{post?.lyst | matchLocale}}</span>
        </div>
        <div *ngIf="post?.lyst_item !== null" class="wrapper-tag item">
          <img src="../../../../../assets/icons/outline/icon-tag.svg" alt="">
          <span>{{post?.lyst_item?.name}}</span>
        </div>
      </div>
    </div>
    <div class="wrapper-toolbar-post">
      <div class="wrapper-toolbar-left">
        <span [routerLink]="[PAGES_AND_PATHS.postLikes.pagePath, post?.id]">{{post?.likes_count}} {{post?.likes_count
          === 1 ? ('LISTS.like' | translate) : ('LISTS.likes' | translate)}}</span>
        <span [routerLink]="[PAGES_AND_PATHS.singlePost.pagePath, post?.id]"> {{post?.comments_count}}
          {{post?.comments_count === 1 ? ('LISTS.comment' | translate) :( 'LISTS.comments' | translate)}}</span>
      </div>
      <div class="wrapper-toolbar-right">
        <div class="wrapper-like"  [ngClass]="{'liked': post?.am_i_liked_this}" (click)="togglePostLike($event)">
          <img class="no-like" src="../../../../../assets/icons/outline/icon-like.svg" alt="">
          <img class="like" src="../../../../../assets/icons/fill/icon-like.svg" alt="">
          <span>{{'LISTS.like' | translate}}</span>
        </div>
        <div (click)="onCallActionSharePost($event)" class="wrapper-share">
          <img src="../../../../../assets/icons/outline/icon-share.svg" alt="">
          <span>
            {{'GENERAL.share' | translate}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div></div>
